<template>
  <div :id="`dropdown-${note.id}`">
    <div class="border-b px-3 py-2 cursor-pointer" v-on:click="toggleChoosing">
      <span class="inline-block">{{ currentDropdown }}</span>
      <down-arrow
        :pointDown="choosing"
        class="inline-block float-right fill-current text-blue-800"
      ></down-arrow>
    </div>
    <div>
      <div class="relative" v-if="choosing">
        <div class="text-left w-full bg-white z-10">
          <div
            class="px-3 py-2 cursor-pointer border-b"
            v-if="note.visibility !== 0"
            v-on:click="changeVisibility(0)"
          >
            Private
          </div>
          <div
            class="px-3 py-2 cursor-pointer border-b"
            v-if="note.visibility !== 2"
            v-on:click="changeVisibility(2)"
          >
            Public
          </div>
          <div
            class="px-3 py-2 cursor-pointer border-b"
            title="Only subscribers of your notebooks can see this note."
            v-if="note.visibility !== 3"
            v-on:click="changeVisibility(3)"
          >
            Subscribe
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownArrow from "../ui/DownArrow.vue";

export default {
  name: "directory-switcher",
  mounted() {
    let directoryDropdown = document.getElementById(`dropdown-${this.note.id}`);

    directoryDropdown.addEventListener("click", function(e) {
      e.stopPropagation(); // this will stop propagation of this event to upper level
    });

    let that = this;
    document.body.addEventListener("click", function(e) {
      that.choosing = false;
    });
  },
  props: ["note"],
  data() {
    return {
      choosing: false
    };
  },
  methods: {
    toggleChoosing: function(e) {
      e.preventDefault();
      this.choosing = !this.choosing;
    },
    async changeVisibility(visibility) {
      this.$loading(true);
      if (this.note.is_encrypted) {
        await this.decryptNote();
      }
      let noteCopy = Object.assign({}, this.note);
      noteCopy.visibility = visibility;
      // this.$store.dispatch('aFavoriteNote', noteCopy);
      this.choosing = false;
      await this.$store.dispatch("CHANGE_PRIVACY", noteCopy);
      this.$loading(false);
    },
    // decrypting is even more straightforward.
    async decryptNote() {
      let noteCopy = Object.assign({}, this.note);
      noteCopy.content = noteCopy.encrypted;
      noteCopy.encrypted = null;
      noteCopy.is_encrypted = 0;
      noteCopy.encrypter_id = null;
      try {
        const res = await this.$store.dispatch("aUpdateNotes", {
          notes: [noteCopy]
        });
      } catch (e) {
        this.$loading(false);
      }
      return true;
    }
  },
  computed: {
    currentDropdown() {
      if (this.note.visibility === 0) {
        return "Private";
      } else if (this.note.visibility === 2) {
        return "Public";
      } else if (this.note.visibility === 3) {
        return "Subcribe";
      }
    }
  },
  components: {
    DownArrow
  }
};
</script>

<style lang="scss">
.vis-dropdown {
  min-width: 100px;
}

.down-arrow {
  max-width: 10px;
  top: 4px;
  position: relative;
  right: 5px;
}
</style>
